/**
 * VueLayers
 * Web map Vue components with the power of OpenLayers
 *
 * @package vuelayers
 * @author Vladimir Vershinin <ghettovoice@gmail.com>
 * @version 0.11.37
 * @license MIT
 * @copyright (c) 2017-2021, Vladimir Vershinin <ghettovoice@gmail.com>
 */
import _Object$keys from '@babel/runtime-corejs3/core-js-stable/object/keys';
import _Object$getOwnPropertySymbols from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/filter';
import _Object$getOwnPropertyDescriptor from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor';
import _Object$getOwnPropertyDescriptors from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors';
import _defineProperty from '@babel/runtime-corejs3/helpers/esm/defineProperty';
import Icon from 'ol/style/Icon';
import { imageStyle } from '../mixin';
import { assert } from '../util/assert';
import { arrayLengthValidator, isEmpty, isEqual, pick } from '../util/minilo';
import { makeWatchers } from '../util/vue-helpers';
import '@babel/runtime-corejs3/core-js-stable/instance/concat';
import _Object$assign from '@babel/runtime-corejs3/core-js-stable/object/assign';

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) { symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { Object.defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }
var script = {
  name: 'vl-style-icon',
  mixins: [imageStyle],
  props: {
    src: String,
    size: {
      type: Array,
      validator: arrayLengthValidator(2)
    },
    img: Image,
    imgSize: {
      type: Array,
      validator: arrayLengthValidator(2)
    },
    anchor: {
      type: Array,
      default: function _default() {
        return [0.5, 0.5];
      },
      validator: arrayLengthValidator(2)
    },
    anchorOrigin: {
      type: String,
      default: 'top-left' // bottom-left, bottom-right, top-left or top-right

    },
    anchorXUnits: {
      type: String,
      default: 'fraction' // pixels, fraction

    },
    anchorYUnits: {
      type: String,
      default: 'fraction' // pixels, fraction

    },
    color: [Array, String],
    crossOrigin: String,
    offset: {
      type: Array,
      default: function _default() {
        return [0, 0];
      },
      validator: arrayLengthValidator(2)
    },
    offsetOrigin: {
      type: String,
      default: 'top-left' // bottom-left, bottom-right, top-left or top-right

    },
    opacity: {
      type: Number,
      default: 1
    },
    scale: {
      type: Number,
      default: 1
    },
    rotateWithView: {
      type: Boolean,
      default: false
    },
    rotation: {
      type: Number,
      default: 0
    }
  },
  methods: {
    /**
     * @return {Icon}
     * @protected
     */
    createStyle: function createStyle() {
      assert(this.src && !this.img || !this.src && this.img, "vl-style-icon one of 'image' or 'src' prop must be provided.");
      assert(!this.img || this.img && !isEmpty(this.imgSize), "vl-style-icon 'imgSize' must be set when image is provided.");
      return new Icon({
        anchor: this.anchor,
        anchorOrigin: this.anchorOrigin,
        anchorXUnits: this.anchorXUnits,
        anchorYUnits: this.anchorYUnits,
        color: this.color,
        crossOrigin: this.crossOrigin,
        offset: this.offset,
        offsetOrigin: this.offsetOrigin,
        opacity: this.opacity,
        scale: this.scale,
        rotateWithView: this.rotateWithView,
        rotation: this.rotation,
        size: this.size,
        src: this.src,
        img: this.img,
        imgSize: this.imgSize
      });
    }
  },
  watch: _objectSpread({
    src: function src(value) {
      if (this.$style && !isEqual(value, this.$style.getSrc())) {
        this.scheduleRefresh();
      }
    },
    size: function size(value) {
      if (this.$style && !isEqual(value, this.$style.getSize())) {
        this.scheduleRefresh();
      }
    },
    anchor: function anchor(value) {
      if (this.$style && !isEqual(value, this.$style.getAnchor())) {
        this.scheduleRefresh();
      }
    },
    color: function color(value) {
      if (this.$style && !isEqual(value, this.$style.getColor())) {
        this.scheduleRefresh();
      }
    },
    opacity: function opacity(value) {
      if (this.$style && !isEqual(value, this.$style.getOpacity())) {
        this.scheduleRefresh();
      }
    },
    scale: function scale(value) {
      if (this.$style && !isEqual(value, this.$style.getScale())) {
        this.scheduleRefresh();
      }
    },
    rotateWithView: function rotateWithView(value) {
      if (this.$style && !isEqual(value, this.$style.getRotateWithView())) {
        this.scheduleRefresh();
      }
    },
    rotation: function rotation(value) {
      if (this.$style && !isEqual(value, this.$style.getRotation())) {
        this.scheduleRefresh();
      }
    }
  }, makeWatchers(['anchorOrigin', 'anchorXUnits', 'anchorYUnits', 'crossOrigin', 'offset', 'offsetOrigin', 'img', 'imgSize'], function () {
    return function () {
      this.scheduleRefresh();
    };
  }))
};

var __vue_script__ = script;
/* template */

/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = undefined;
/* component normalizer */

function __vue_normalize__(template, style, script$$1, scope, functional, moduleIdentifier, createInjector, createInjectorSSR) {
  var component = (typeof script$$1 === 'function' ? script$$1.options : script$$1) || {}; // For security concerns, we use only base name in production mode.

  component.__file = "style.vue";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;

  return component;
}
/* style inject */

/* style inject SSR */


var Style = __vue_normalize__({}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, undefined, undefined);

function plugin(Vue) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (plugin.installed) {
    return;
  }

  plugin.installed = true;
  options = pick(options, 'dataProjection');

  _Object$assign(Style, options);

  Vue.component(Style.name, Style);
}

export default plugin;
export { Style, plugin as install };
